// Job Type tags. See docs/03-jobs-skills §3.2.
export const JOB_TYPES = [
    'Tank',
    'MeleeDPS',
    'RangedDPS',
    'MagicDPS',
    'Healer',
    'Support',
    'Summoner',
];
/**
 * Ally slot capacity per current job tier. See docs/02-party-character §2.1.1
 * and ADR 0005 §2.1 for the Tier 4 = 4 fixed value rationale.
 */
export const TIER_ALLY_SLOT_CAP = {
    1: 1,
    2: 2,
    3: 4,
    4: 4,
};
//# sourceMappingURL=jobs.js.map